// app/javascript/controllers/accordion_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "content", "icon"];

  connect() {
    // Fermer tous les modules
    this.contentTargets.forEach((content, i) => {
      content.classList.add("hidden");
      this.triggerTargets[i].classList.remove("bg-black", "text-white");
      this.triggerTargets[i].classList.add("bg-gray-4");
      this.iconTargets[i].classList.remove("rotate-180");
    });
    // Ouvrir le module d'index 1 (GO4SBOOK)
    // this.openModule(1);
  }

  toggle(event) {
    // Trouver l'index du trigger cliqué dans la liste des triggers
    const trigger = event.currentTarget.closest(
      '[data-accordion-landing-target="trigger"]'
    );
    const moduleIndex = this.triggerTargets.indexOf(trigger);

    if (moduleIndex === -1) return; // Sécurité

    // Si déjà ouvert, le fermer
    if (
      this.contentTargets[moduleIndex] &&
      !this.contentTargets[moduleIndex].classList.contains("hidden")
    ) {
      this.contentTargets[moduleIndex].classList.add("hidden");
      this.triggerTargets[moduleIndex].classList.remove(
        "bg-black",
        "text-white"
      );
      this.triggerTargets[moduleIndex].classList.add("bg-gray-4");
      this.iconTargets[moduleIndex].classList.remove("rotate-180");
    } else {
      // Fermer tous les modules
      this.contentTargets.forEach((content, i) => {
        content.classList.add("hidden");
        this.triggerTargets[i].classList.remove("bg-black", "text-white");
        this.triggerTargets[i].classList.add("bg-gray-4");
        this.iconTargets[i].classList.remove("rotate-180");
      });
      // Ouvrir celui cliqué
      this.openModule(moduleIndex);
    }
  }

  openModule(index) {
    // Ajout d'une animation pour ouvrir le module
    this.contentTargets[index].classList.remove("hidden");
    this.contentTargets[index].style.maxHeight =
      this.contentTargets[index].scrollHeight + "px";
    setTimeout(() => {
      this.contentTargets[index].style.maxHeight = null;
    }, 300); // Durée de l'animation

    this.triggerTargets[index].classList.remove("bg-gray-4");
    this.triggerTargets[index].classList.add("bg-black");
    this.triggerTargets[index].classList.add("text-white");
    this.iconTargets[index].classList.add("rotate-180");
  }
}
